import { render } from "./payslip-request-model.vue?vue&type=template&id=c2b849a8"
import script from "./payslip-request-model.vue?vue&type=script&lang=js"
export * from "./payslip-request-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__